import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IPoste, IPosteRequest } from 'src/app/shared/models/poste';

@Injectable({ providedIn: 'root' })
export class PosteService {

  private readonly apiUrl = '/api/v1/postes';

  constructor(private http: HttpClient) {}

  getAll(): Observable<IPoste[]> {
    return this.http.get<IPoste[]>(this.apiUrl);
  }

  create(request: IPosteRequest): Observable<IPoste> {
    return this.http.post<IPoste>(this.apiUrl, request);
  }

  update(id: string, request: IPosteRequest): Observable<IPoste> {
    return this.http.put<IPoste>(`${this.apiUrl}/${id}`, request);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
